import { isDriverAndFoodUIOptimisation } from '../experiment/getDriverAndFoodUIOptimisationExperiment';

// SPCB-30284 需求 rules base 支持 case
const CaseOptionMatch = '30284-CaseOptionMatch';
const OtherFrequentlyAsked = '31864-OtherFrequentlyAsked';
const ShopeeFoodNewUI = '36127-ShopeeFoodNewUI';

// 需要做发布顺序兼容 or 版本控制的才加进来
// key 的拼接规则统一为：{jira单号}-{feature简短的描述}
export const getSupportFeatures = () => {
  const supportFeatures = [CaseOptionMatch, OtherFrequentlyAsked];
  if (isDriverAndFoodUIOptimisation()) {
    supportFeatures.push(ShopeeFoodNewUI);
  }

  return supportFeatures;
};

export const SUPPORT_FEATURES_RELATED_API = [
  '/composed_init_session',
  '/init_session_v1',
  '/init_session',
  '/message',
  '/get_category_intent_list',
];
